/*
 * Work Order Container
 */

import { WithTranslation, withTranslation } from 'react-i18next';
import { IWorkOrder } from '../../models';
import { IinitialState } from '../../reducers';
import WorkOrderForm from './WorkOrderForm';
import { connect } from 'react-redux';
import { getCurrentWorkOrder, selectWorkOrdersByInstallBaseID } from '../../reducers/workOrderReducer';
import {
    addWorkOrder,
    saveWorkOrderClosingNotes,
    saveWorkOrder,
    toggleEditPartModalForm,
    updateWorkOrder
} from '../../actions/workOrderActions';
import { selectIsLoading } from '../../reducers/commonReducers';
import { selectIsMPFormLocked } from '../../reducers/commonSelectors';
import { getAssignedJobs } from '../../actions/manageJobActions';
import { setDecommissionAsset } from '../../actions/manageInventoryActions';

interface Iprops {
    selectedWorkOrder: IWorkOrder;
}

const mapStateToProps = (state: IinitialState, ownProps: Iprops & WithTranslation) => {
    const selectedInstall = state.manageInventory.installBasesByID[ownProps.selectedWorkOrder.installBaseID];
    const selectedProduct = state.manageInventory.productsByID[selectedInstall?.materialID ?? ''];
    const selectedWorkOrders = selectWorkOrdersByInstallBaseID(state, selectedInstall?.id ?? '');
    const currentWorkOrder = getCurrentWorkOrder(state);
    return {
        loading: selectIsLoading(state),
        selectedWorkOrders,
        selectedProduct,
        currentWorkOrder,
        standardOptions: state.productInfo.standardOptions,
        selectedInstallBaseID: selectedInstall?.id ?? '',
        disabled: true,
        isHistoricalMode: selectIsMPFormLocked(state),
        selectedWorkOrder: ownProps.selectedWorkOrder,
        jobTypeID: state.manageJob.selectedJob.jobTypeID,
        setDecommissionAsset,
        selectedInstall,
        manageInventory: state.manageInventory,
        decommissionAsset: state.manageInventory.decommissionAsset[ownProps.selectedWorkOrder.installBaseID]
    };
};

export const WorkOrderContainer = withTranslation('manageWorkOrder')(
    connect(mapStateToProps, {
        getJobs: getAssignedJobs,
        addWorkOrder,
        saveWorkOrderClosingNotes,
        saveWorkOrder,
        updateWorkOrder,
        toggleEditPartModalForm,
        setDecommissionAsset
    })(WorkOrderForm)
);
